import React from "react";
import PropTypes from "prop-types";
import {TABS} from "./adminUpdateUtils";

const TabButton = ({tab, label, activeTab, onSelect}) => (
    <li className="nav-item" style={{flexShrink: 0}}>
        <button className={`nav-link ${activeTab === tab ? "active" : ""}`}
                type="button"
                onClick={() => onSelect(tab)}>
            {label}
        </button>
    </li>
);

TabButton.propTypes = {
    tab: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    activeTab: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired
};

const getVisibleTabs = (showAdminLink, showRestricted) => [
    {tab: TABS.DETAILS, label: "Details", visible: true},
    {tab: TABS.ADMIN, label: "Admin Link", visible: showAdminLink},
    {tab: TABS.UPDATE, label: "Update", visible: showRestricted},
    {tab: TABS.PREFERENCES, label: "Preferences", visible: showRestricted},
    {tab: TABS.EMPLOYMENT, label: "Employment", visible: showRestricted}
].filter(({visible}) => visible);

const AdminTabsNav = ({activeTab, onSelect, showAdminLink, showRestricted}) => (
    <ul className="nav nav-tabs admin-update-tabs"
        role="tablist"
        style={{flexWrap: "nowrap", overflowX: "auto", overflowY: "hidden"}}>
        {getVisibleTabs(showAdminLink, showRestricted).map(({tab, label}) => (
            <TabButton key={tab} tab={tab} label={label} activeTab={activeTab} onSelect={onSelect}/>
        ))}
    </ul>
);

AdminTabsNav.propTypes = {
    activeTab: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    showAdminLink: PropTypes.bool.isRequired,
    showRestricted: PropTypes.bool.isRequired
};

export default AdminTabsNav;
